// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopSection_container__1l6mw","shopImage":"ShopSection_shopImage__10a-d","vipImage":"ShopSection_vipImage__3FQ0Y","buttonWrapper":"ShopSection_buttonWrapper__2WBnK"};